import {StringUtils} from '../string.utils';
import {AppUtils} from '../app.utils';

export class ApiJsonResult {

    public status: string;
    public message: string;
    public appMessage: string;
    public responseCode: number;
    public outputparam1: string;
    public outputparam2: string;
    public outputjson: string;
    public trackerjson: string;

    constructor() {
    }

    public static populate(data: any): ApiJsonResult {
        const apijsonResult: ApiJsonResult = new ApiJsonResult();
        apijsonResult.status = data.status;
        apijsonResult.message = data.message;
        apijsonResult.appMessage = data.appMessage;
        apijsonResult.responseCode = data.responseCode;
        apijsonResult.outputparam1 = data.outputparam1;
        apijsonResult.outputparam2 = data.outputparam2;
        apijsonResult.outputjson = data.outputjson;
        apijsonResult.trackerjson = data.trackerjson;
        return apijsonResult;
    }

    public static apiResponse(data: any): ApiJsonResult {
        const apijsonResult: ApiJsonResult = JSON.parse(data.text());
        if (!StringUtils.isEmpty(apijsonResult.appMessage)) {
            AppUtils.setTransientMsg(apijsonResult.appMessage);
        }
        return apijsonResult;
    }

    public static isRequestSuccessful(apijsonResult: ApiJsonResult): boolean {
        return apijsonResult != null && apijsonResult.status != null && apijsonResult.status == 'OK';
    }


}
